import React, { createContext, useContext, useState } from 'react';
import { ccRequest } from '../../services/CCPublicationService';
import useCCResource from './useCCResource';

const YieldContext = createContext(null);
export const useYield = () => useContext(YieldContext);
export default function YieldProvider({ children, active, identity }) {
  const [view, setView] = useState('crops');
  const [year, setYear] = useState(2025);
  const [stage, setStage] = useState('final');
  const [revision, setRevision] = useState(0);
  const [record, setRecord] = useState(null);
  const enabled = active && view === 'yield';
  const catalog = useCCResource(enabled ? JSON.stringify(['yield', identity, revision]) : null,
    signal => ccRequest('yield/datasets', { signal }));
  const dataset = catalog.data?.datasets?.[0] || null;
  const yearInfo = dataset?.years.find(y => y.year === year);
  const params = dataset ? { dataset_id: dataset.id, year, stage } : null;
  const key = enabled && yearInfo ? JSON.stringify([identity, dataset.id, dataset.version, year, stage, revision]) : null;
  const summary = useCCResource(key, signal => ccRequest('yield/summary', { params, signal }));
  const selected = record?.key === key && key ? record.feature : null;
  return <YieldContext.Provider value={{ active: enabled, view, setView, year, stage, setYear, setStage,
    catalog, dataset, yearInfo, params, queryKey: key, summary, selected,
    select: (feature, owner = key) => setRecord(feature ? { key: owner, feature } : null),
    retry: () => setRevision(n => n + 1) }}>{children}</YieldContext.Provider>;
}
